import Form, { FormField } from '@thinknimble/tn-forms'

import {
  MustMatchValidator,
  EmailValidator,
  RequiredValidator,
  MinLengthValidator,
  Validator,
} from '@thinknimble/tn-validators'

export class FileValidator extends Validator {
  static fileTypes = {
    images: 'image/*',
    jpg: 'image/jpg',
    png: 'image/png',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    csv: 'csv',
    pdf: 'pdf',
    text: 'txt',
    txt: 'text',
  }
  constructor({
    fileType = null,
    message = 'File size/type invalid',
    code = 'invalidFile',
    type = 'file',
    size = 10,
  } = {}) {
    super({ message, code })
    Object.assign(this, {
      fileType: fileType,
      type: type,
      size: size,
    })
  }

  call(value) {
    //this.matchingVal = extraArgs
    if (!value) {
      throw new Error(JSON.stringify({ code: this.code, message: this.message }))
    }
    if (this.type == 'file') {
      // first check the extension and invalidate if the extension is incorrect
    }
  }
}

export class UserRegistrationForm extends Form {
  static firstName = new FormField({ validators: [new RequiredValidator()] })
  static lastName = new FormField({ validators: [new RequiredValidator()] })

  rawData() {
    return this.value
  }
}

export class ChangePasswordForm extends Form {
  static password = new FormField({
    validators: [
      new RequiredValidator(),
      new MinLengthValidator({ minLength: 8, message: 'Minimum Length of 8 required' }),
    ],
  })
  static confirmPassword = new FormField({ validators: [] })
  static token = new FormField({ validators: [new RequiredValidator()] })
  static uid = new FormField({ validators: [new RequiredValidator()] })
  static dynamicFormValidators = {
    confirmPassword: [new MustMatchValidator({ matcher: 'password' })],
  }
}

export class UserLoginForm extends Form {
  static email = new FormField({ validators: [new RequiredValidator()] })
  static password = new FormField({ validators: [new RequiredValidator({})] })
  static create(obj = {}) {
    new UserLoginForm(obj)
  }
}
